import React, { useState, useEffect } from 'react';
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Checkbox,
    FormControl,
    InputLabel,
    Select,
    ListItemText,
    Input
} from "@mui/material";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import BackButton from '../../components/BackButton/BackButton';
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from 'react-redux';
import { adminGetAccountTypeList } from '../../redux/actions/adminGetAccountTypeListAction';
import { adminAccountTypeMapping } from '../../redux/actions/adminAccountTypeMappingAction';
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import { adminGetAccountTypeMapping } from '../../redux/actions/aminGetAccountTypeMappingAction';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import { adminAccountTypeMappingDelete } from '../../redux/actions/adminAccountTypeMappingDeleteAction';
import CustomButton from '../../components/CustomButton/CustomButton';
import { Delete } from '@mui/icons-material';
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import val from "../../getThemeDetails";
const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const AdminMappingAccountType = () => {

    const classes = useStyles();

    const [walletOwnerID, setwalletOwnerID] = useState('');
    const [accountType, setaccountType] = useState('');
    const [walletOwnerIdResp, setwalletOwnerIdResp] = useState([]);
    const [accountTypeList, setaccountTypeList] = useState([]);
    const [mappingSet, setmappingSet] = useState(false);
    const [mappingDescription, setmappingDescription] = useState('');
    const [notificationOpen, setnotificationOpen] = useState(false);
    const [searchWalletOwnerID, setsearchWalletOwnerID] = useState('');
    const [searchBool, setsearchBool] = useState(false);
    const [isLoading, setisLoading] = useState(false);
    const [mappingArr, setmappingArr] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [deleteDecription, setdeleteDecription] = useState('')
    const [deleteSet, setdeleteSet] = useState(false);
    const [deleteNotify, setdeleteNotify] = useState(false);

    const getWalletOwnerIdRes = useSelector(({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList);
    const adminAccountTypeMappingRes = useSelector(({ adminAccountTypeMapping }) => adminAccountTypeMapping);
    const adminGetAccountTypeMappingRes = useSelector(({ adminGetAccountTypeMapping }) => adminGetAccountTypeMapping);
    const adminAccountTypeMappingDeleteRes = useSelector(({ adminAccountTypeMappingDelete }) => adminAccountTypeMappingDelete);
    const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
    const adminGetAccountTypeListRes = useSelector(({ adminGetAccountTypeList }) => adminGetAccountTypeList);
    var authToken = regenerateTokenRes.data.AuthToken;

    const dispatch = useDispatch();

    const handleChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'walletOwnerID') {
            setaccountType('');
            setwalletOwnerID(value)
            disabledBankTypes(value, mappingArr, accountTypeList);
        }
        if (name === 'accountType') {
            if (value.includes('all')) {
                setaccountType(
                    accountType.length === [].concat(accountTypeList).filter((ch) => !ch.disabled).length
                        ? []
                        : [].concat(accountTypeList).filter((ch) => !ch.disabled).map((x) => x.accountName)
                );
            } else {
                setaccountType(value);
            }
        }
    }

    const disabledBankTypes = (wid, marr, cclist) => {
        let mapped = [].concat(marr).filter(ch => ch.walletOwnerId === wid).map(x => x.name);
        for (let i = 0; i < cclist.length; i++) {
            cclist[i].disabled = false;

            for (let j = 0; j < mapped.length; j++) {
                if (cclist[i].accountName == mapped[j]) {
                    cclist[i].disabled = true;
                    break;
                }
            }
        }
        setaccountTypeList(cclist);
    }

    const getIds = (ma, ar) => {
        let fa = [];
        let maKey = ma.map(x => x.accountName);
        for (let i = 0; i < ar.length; i++) {
            fa.push(ma[maKey.indexOf(ar[i])].id)
        }
        return fa;
    }

    const createMappingAccountType = () => {
        console.log('accountTypeList: ', accountTypeList);
        console.log('accountType: ', accountType);
        const req = {
            actionCustomerMasterRequestVO: {
                accId: getIds(accountTypeList, accountType).length == 0 ? '' : getIds(accountTypeList, accountType),
                walletOwnerId: walletOwnerID
            }
        }
        console.log('sdfgh: ', req)
        dispatch(adminAccountTypeMapping(req, authToken));
        setmappingSet(true);
        setaccountType('');
        setwalletOwnerID('');
    }

    const getMappingRespFunc = () => {
        if (mappingSet) {
            if (adminAccountTypeMappingRes.data.status === 'success') {
                setmappingDescription(adminAccountTypeMappingRes.data.description);
                setnotificationOpen(true);
                submitsearchfunc()
            }
            if (adminAccountTypeMappingRes.data.status === 'failed') {
                setmappingDescription(adminAccountTypeMappingRes.data.description);
                setnotificationOpen(true);
                if (
                    adminAccountTypeMappingRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    adminAccountTypeMappingRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    useEffect(() => {
        getMappingRespFunc();
    }, [adminAccountTypeMappingRes.data.status]);

    useEffect(() => {
        const req = {
            actionCustomerMasterRequestVO: {
                id: "",
                accountName: ""

            }
        }
        dispatch(adminGetAccountTypeList(req, authToken))
    }, []);

    const getAccountTypeResp = () => {
        if (adminGetAccountTypeListRes.data.status === 'success') {
            setaccountTypeList(adminGetAccountTypeListRes.data.customerMasterDetailsRequestVOList);
        }
        if (adminGetAccountTypeListRes.data.status === 'failed') {
            if (
                adminGetAccountTypeListRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                adminGetAccountTypeListRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }

    useEffect(() => {
        getAccountTypeResp()
    },[]);

    const getWalletOwnerIdFunc = () => {
        dispatch(
            getWalletOwnerIdAndNameList(
                {
                    loginDetails: {
                        // adminId: regenerateTokenRes.data.partnerId
                            adminId:val.adminIDS
                    }
                },
                authToken
            )
        )
    }

    useEffect(() => {
        if (getWalletOwnerIdRes.data.status === 'success') {
            setwalletOwnerIdResp(getWalletOwnerIdRes.data.ownerList);
        }
        if (getWalletOwnerIdRes.data.status === 'failed') {
            if (
                getWalletOwnerIdRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                getWalletOwnerIdRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }, [getWalletOwnerIdRes.data.status])

    useEffect(() => {
        getWalletOwnerIdFunc();
    }, [authToken]);

    const handleNoticationClose = () => {
        setnotificationOpen(false);
        setmappingDescription('');
    }

    const closeDeleteNotification = () => {
        setdeleteNotify(false);
        setdeleteDecription('');
    }

    const chagneSearchWalletOwnerId = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'searchWalletOwnerID') {
            setsearchWalletOwnerID(value);
        }
    }

    const submitsearchfunc = () => {
        setsearchBool(true);
        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: searchWalletOwnerID === 'Select Owner Id' ? '' : searchWalletOwnerID
            }
        }
        dispatch(adminGetAccountTypeMapping(req, authToken));
        setisLoading(true);

    }

    useEffect(() => {
        submitsearchfunc()
    }, [])

    const setAccountTypeMappigRespFunc = () => {
        if (searchBool) {
            if (adminGetAccountTypeMappingRes.data.status == 'success') {
                setmappingArr(adminGetAccountTypeMappingRes.data.list);
                setisLoading(false);
                setsearchBool(false);
            }
            if (adminGetAccountTypeMappingRes.data.status == 'failed') {
                setmappingArr([]);
                setisLoading(false);
                setsearchBool(false);
                if (
                    adminGetAccountTypeMappingRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    adminGetAccountTypeMappingRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    useEffect(() => {
        setAccountTypeMappigRespFunc()
    }, [adminGetAccountTypeMappingRes.data.status]);

    useEffect(() => {
		if (adminGetAccountTypeMappingRes.data.status == "success") {
			setPage(0);
		}
	}, [adminGetAccountTypeMappingRes.data.status]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const deleteModal = mappingId => {
        setdeleteSet(true);
        const req = {
            actionCustomerMasterRequestVO: {
                mappingId: mappingId
            }
        }
        dispatch(adminAccountTypeMappingDelete(req, authToken));
    }

    const handleDeleteFunc = () => {
        if (deleteSet) {
            if (adminAccountTypeMappingDeleteRes.data.status === 'success') {
                setdeleteDecription(adminAccountTypeMappingDeleteRes.data.description);
                setdeleteNotify(true);
                submitsearchfunc();
                setaccountType('')
                setwalletOwnerID('')
            }
            if (adminAccountTypeMappingDeleteRes.data.status === 'failed') {
                setdeleteDecription(adminAccountTypeMappingDeleteRes.data.description);
                setdeleteNotify(true);
                if (
                    adminAccountTypeMappingDeleteRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    adminAccountTypeMappingDeleteRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (adminAccountTypeMappingDeleteRes.data.status === 'NOT FOUND') {
                setdeleteDecription(adminAccountTypeMappingDeleteRes.data.description);
                setdeleteNotify(true);
            }
        }
    }

    useEffect(() => {
        handleDeleteFunc();
    }, [adminAccountTypeMappingDeleteRes.data.status])

    return (
        <>
            <Layout>
                <BackButton />
                <Card>
                    <DialogTitle>Mapping Bank Type</DialogTitle>
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Owner ID"
                                fullWidth={true}
                                variant='standard'
                                name="walletOwnerID"
                                value={walletOwnerID || "Select Owner Id"}
                                onChange={handleChange}
                            >
                                <MenuItem value="Select Owner Id" selected="Select Owner Id">
                                    Select Owner Id
                                </MenuItem>
                                {walletOwnerIdResp &&
                                    [].concat(walletOwnerIdResp).map((x) => (
                                        <MenuItem key={x.split("-")[0]} value={x.split("-")[0]}>{x}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <FormControl className={classes.formControl} style={{ width: '100%', marginTop: '-4px' }}>
                                <InputLabel id='multipleAccountTypeSelect'>Select Bank Type</InputLabel>
                                <Select
                                    labelId='multipleAccountTypeSelect'
                                    multiple
                                    fullWidth={true}
                                    value={accountType || []}
                                    input={<Input />}
                                    renderValue={selected => selected.join(', ')}
                                    onChange={handleChange}
                                    name='accountType'
                                >
                                    <MenuItem key='all' value='all'>
                                        <Checkbox color='primary' checked={accountType.length === [].concat(accountTypeList).filter((ch) => !ch.disabled).length} />
                                        <ListItemText primary='Select All' />
                                    </MenuItem>
                                    {
                                        accountTypeList && [].concat(accountTypeList).map((x, index) => {
                                            return (
                                                <MenuItem key={index} value={`${x.accountName}`} disabled={x.disabled}>
                                                    <Checkbox color='primary' checked={accountType.indexOf(`${x.accountName}`) > -1} />
                                                    <ListItemText primary={x.accountName} />
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                    margin: "8px 8px"
                                }}
                                variant="contained"
                                onClick={createMappingAccountType}
                            >
                                Create
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>
                <Card>
                    <DialogTitle>Search</DialogTitle>
                    <Grid container spacing={2} style={{ padding: "25px" }}>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Owner ID"
                                fullWidth={true}
                                name="searchWalletOwnerID"
                                value={searchWalletOwnerID || "Select Owner Id"}
                                onChange={chagneSearchWalletOwnerId}
                            >
                                <MenuItem value="Select Owner Id" selected="Select Owner Id">
                                    Select Owner Id
                                </MenuItem>
                                {walletOwnerIdResp &&
                                    [].concat(walletOwnerIdResp).map((x) => (
                                        <MenuItem key={x.split("-")[0]} value={x.split("-")[0]}>{x}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                    margin: "8px 8px"
                                }}
                                variant="contained"
                                onClick={submitsearchfunc}
                            >
                                Search
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>
                {
                    isLoading ? (<LoadingSpinner />) : mappingArr == undefined || mappingArr.length == 0 || !mappingArr ? (
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}
                                className="themeText"
                                    
                                    >
                                        Report Table
                                    </Typography>
                                </Grid>
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Alert
                                        className="my-3 tableHeaderColor"
                                        variant="secondary"
                                        style={{ color: "white" }}
                                    >
                                        No Records Found!
                                    </Alert>
                                </Grid>
                            </Grid>
                        </Card>
                    ) : (
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}
                                className="themeText"
                                    
                                    >
                                        Report Table
                                    </Typography>
                                </Grid>
                                <TableContainer component={Paper} className="my-3">
                                    <Table
                                        className={classes.table}
                                        size="small"
                                        aria-label="a dense table"
                                    >
                                        <TableHead>
                                            <TableRow className="tableHeaderColor">
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Mapping ID
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Bank Type
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Owner Name
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Action
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {mappingArr &&
                                                []
                                                    .concat(mappingArr)
                                                    .slice(
                                                        page * rowsPerPage,
                                                        page * rowsPerPage + rowsPerPage
                                                    )
                                                    .map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center"> {row.mappingId} </TableCell>
                                                            <TableCell align="center"> {row.name} </TableCell>
                                                            <TableCell align="center">{row.walletOwnerName}</TableCell>
                                                            <TableCell align="center">
                                                                <CustomButton
                                                                    style={{
                                                                        padding: "8px"
                                                                    }}
                                                                    onClick={() => deleteModal(row.mappingId)}
                                                                >
                                                                    <Delete style={{ color: "#fff" }} />
                                                                </CustomButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={[].concat(mappingArr).length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </TableContainer>
                            </Grid>
                        </Card>
                    )
                }
            </Layout>
            {adminAccountTypeMappingRes.data.status == "success" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {mappingDescription}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {adminAccountTypeMappingRes.data.status == "failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {mappingDescription}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {adminAccountTypeMappingDeleteRes.data.status == "success" && (
                <div>
                    <Dialog open={deleteNotify} onClose={closeDeleteNotification}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {deleteDecription}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={closeDeleteNotification}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {adminAccountTypeMappingDeleteRes.data.status == "failed" && (
                <div>
                    <Dialog open={deleteNotify} onClose={closeDeleteNotification}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {deleteDecription}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={closeDeleteNotification}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {adminAccountTypeMappingDeleteRes.data.status == "NOT FOUND" && (
                <div>
                    <Dialog open={deleteNotify} onClose={closeDeleteNotification}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {deleteDecription}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={closeDeleteNotification}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )
}

export default AdminMappingAccountType;